import { IonContent, IonPage, IonCol, IonRow, IonText, IonGrid } from '@ionic/react';
import React from 'react';
import PageHeader from '../../components/PageHeader/PageHeader';
import './BibleTranslationNoticePage.scss';
import IRouteInfo from '../../interfaces/IRouteInfo';

const BibleTranslationNoticePage: React.FC<IRouteInfo> = (props: IRouteInfo) => {

  return (
    <IonPage>
      <PageHeader {...props} showBackButton={true}></PageHeader>
      <IonContent>
        <IonGrid fixed={true}>
          <IonRow >
            <IonCol className="announcement-text">
              <p>
              The text of the Holy Bible, New Living Translation, may be quoted in any form (written, visual, electronic, or audio) up to and inclusive of five hundred (500) verses without express written permission of the publisher, provided that the verses quoted do not account for more than twenty-five percent (25%) of the work in which they are quoted, and provided that a complete book of the Bible is not quoted. TYNDALE, New Living Translation, NLT, the New Living Translation logo, and Tyndale’s Quill logo are registered trademarks of Tyndale House Publishers.
              </p>
              <p>
              Scripture quotations are from the ESV® Bible (The Holy Bible, English Standard Version®), copyright © 2001 by Crossway, a publishing ministry of Good News Publishers. Used by permission. All rights reserved. May not copy or download more than 500 consecutive verses of the ESV Bible or more than one half of any book of the ESV Bible.
              </p>
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonContent>
    </IonPage>
  );
};

export default BibleTranslationNoticePage;